<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'candidates'"
    />
    <call-out-box
      :CallOutTitle="'RARE LEVELS THE PLAYING FIELD. WE HELP YOU FULFIL YOUR PROMISE THROUGH OUR CAREER GUIDANCE AND MULTI AWARD-WINNING DEVELOPMENT.'"
      :CallOutTitleSmall="'RARE LEVELS THE PLAYING FIELD. WE HELP YOU FULFIL YOUR PROMISE THROUGH OUR CAREER GUIDANCE AND MULTI AWARD-WINNING DEVELOPMENT.'"
      :IsH2="true"
    />

    <rare-person-quote
      :quoteTitle="'The best advice'"
      :quoteBody="'It was like a light bulb switched on when Rare suggested advertising and communications to me.'"
      :quoteName="'Yewande Ogunkoya'"
      :quotePosition="'Managing Partner, Craft Media London, Cannes Young Lions Winner, WACL Future Leader Award Winner and Rare Alumnus'"
      :quotePortraightImage="'YewandeSokan'"
      :quoteImageSide="'left'"
    />

    <programmes-carousel
      :variation="'candidates'"
    />

    <rare-person-quote
      :quoteTitle="'The best development'"
      :quoteBody="'I don’t just feel I’m better at passing application processes; I feel I’ve honed the critical and analytical skills needed for success generally.'"
      :quoteName="'David Odejayi'"
      :quotePosition="'Disputes lawyer and Rare alumnus'"
      :quoteLogoImage="'AllenOvery'"
      :quotePortraightImage="'DavidOdejayi'"
      :quoteImageSide="'right'"
    />

    <development-carousel
      :variation="'candidates'"
    />

    <rare-person-quote
      :quoteTitle="'The best data'"
      :quoteBody="'Our Contextual Recruitment System tells employers about the context in which your achievements were made, allowing them to recognise brilliant outperformers from disadvantaged backgrounds.'"
      :quoteBodySmall="'Our Contextual Recruitment System allows employers to recognise brilliant outperformers from disadvantaged backgrounds.'"
      :quoteName="'Kura Dione-Warren'"
      :quotePosition="'Director, Strategic Development'"
      :quoteLogoImage="'Rare'"
      :quotePortraightImage="'KuraDioneWarren'"
      :quoteImageSide="'left'"
    />

    <candidates-contexulised :numberOfCandidates="'2,000,000'"/>

    <candidates-how-it-works
    @openLegalModal="openLegalModal"/>

    <candidates-process-row/>

    <candidates-data-row
      :raresSupport="'9/10'"
      :hiredAfterArticles="'27x'"
      :hiredAfterConsult="'1000x'"
      :employers="'150+'"
      :disadvantagedCandidatesHired="'61%'"
    />

    <clients-carousel/>

    <rare-ready/>

    <rare-awards/>
  </div>
</template>

<script>

import HeaderHeroImage from '../../components/header/HeaderHeroImage';

import RarePersonQuote from '../../components/commonSections/RarePersonQuote';
import RareCallOutBox from '../../components/commonSections/RareCallOutBox';

import programmesCarousel from '../../components/carousels/programmesCarousel';
import developmentCarousel from '../../components/carousels/developmentCarousel';
import RareAwards from '../../components/carousels/awardsCarousel';

import RareCandidatesTargetOxbridge from './components/RareCandidatesTargetOxbridge';
import RareCandidatesHeaderContents from './components/RareCandidatesHeaderContents';
import RareCandidatesReady from './components/RareCandidatesReady';
import RareCandidatesContexulised from './components/RareCandidatesContexulised';
import RareCandidatesDataRow from './components/RareCandidatesDataRow';
import RareCandidatesProcessRow from './components/RareCandidatesProcessRow';
import RareCandidatesHowItWorks from './components/RareCandidatesHowItWorks';
import RareCandidatesClientsCarousel from './components/RareCandidatesClientsCarousel';

export default {
  name: 'candidates',
  components: {
    'header-image': HeaderHeroImage,
    'rare-candidates-header-contents': RareCandidatesHeaderContents,
    'rare-person-quote': RarePersonQuote,
    'call-out-box': RareCallOutBox,
    'programmes-carousel': programmesCarousel,
    'development-carousel': developmentCarousel,
    'rare-awards': RareAwards,
    'candidates-target-oxbridge': RareCandidatesTargetOxbridge,
    'rare-ready': RareCandidatesReady,
    'candidates-contexulised': RareCandidatesContexulised,
    'candidates-data-row': RareCandidatesDataRow,
    'candidates-process-row': RareCandidatesProcessRow,
    'candidates-how-it-works': RareCandidatesHowItWorks,
    'clients-carousel': RareCandidatesClientsCarousel,
  },
  data() {
    return {
      headerContents: 'rare-candidates-header-contents',
      legalModalOpen: false,
      legalModalHeader: null,
      legalModalContent: null,
      oldYPos: 0,
    };
  },
  methods: {
    openLegalModal(header, content) {
      this.oldYPos = window.scrollY;
      window.scrollTo(0, 0);
      this.legalModalHeader = header;
      this.legalModalContent = content;
      this.legalModalOpen = true;
    },
    closeLegalModal() {
      window.scrollTo(0, this.oldYPos);
      this.legalModalOpen = false;
    },
  },
  mounted() {
  },
};
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/pages/candidates/candidates.vue